import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import FocusLock from 'react-focus-lock';
import focus from '../../../utils/accessibility-focus';
import styles from './overlay-focus-lock.scss';
export default class OverlayFocusLock extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "lastFocusedElement", void 0);
    _defineProperty(this, "ref", void 0);
    _defineProperty(this, "handleClickOutside", event => {
      const eventTarget = event.target;
      if (this.ref && !this.ref.contains(eventTarget)) {
        this.disableFocusLock(() => {
          focus(eventTarget);
        });
      }
    });
    _defineProperty(this, "saveRef", ref => this.ref = ref);
    this.lastFocusedElement = null;
    this.state = {
      isFocusLockEnabled: false
    };
  }
  componentDidUpdate(prevProps) {
    const {
      isEnabled
    } = this.props;
    if (isEnabled && !prevProps.isEnabled) {
      // enable focus lock with slight delay to allow it catch focusable elements
      this.lastFocusedElement = document.activeElement;
      setTimeout(() => this.enableFocusLock(), 200);
    }
    if (!isEnabled && prevProps.isEnabled) {
      this.disableFocusLock();
    }
  }
  enableFocusLock() {
    this.setState({
      isFocusLockEnabled: true
    });
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }
  disableFocusLock(callback) {
    this.setState({
      isFocusLockEnabled: false
    }, callback);
    document.removeEventListener('mousedown', this.handleClickOutside, true);
    focus(this.lastFocusedElement);
  }
  render() {
    const {
      children
    } = this.props;
    const {
      isFocusLockEnabled
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.saveRef,
      className: styles.container
    }, /*#__PURE__*/React.createElement(FocusLock, {
      disabled: !isFocusLockEnabled
    }, children));
  }
}
//# sourceMappingURL=overlay-focus-lock.js.map